"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SpanishCustomLabels = [
    {
        id: "spanish-custom-labels",
        language: "es",
        labels: {
            credits: {
                general: "Créditos"
            },
            Question: {
                learnosity: {
                    calculator: "Calculadora",
                    cancel: "Cancelar",
                    checkAnswer: "Comprobar Respuesta",
                    checkAnswers: "Comprobar Respuestas",
                    clear: "Borrar",
                    colorPicker: "Selector de color",
                    continuelabel: "Continuar",
                    copy: "Copiar",
                    correctAnswer: "Respuesta Correcta",
                    correctAnswers: "Respuestas Correctas",
                    cut: "Cortar",
                    listen: "escuchar",
                    loading: "cargando",
                    next: "Siguiente",
                    previous: "Anterior",
                    redo: "Rehacer",
                    undo: "Deshacer",
                    point: "Punto",
                    reset: "Reiniciar",
                    maxPlayAttempts: "Alcanzaste el límite de reproducción",
                    minResponseMessage: "Esta pregunta requiere al menos 1 respuesta.",
                    minResponsesMessage: "Esta pregunta requiere al menos {{minSelection}} respuestas.",
                    maxResponseMessage: "Sólo se permite 1 respuesta.",
                    maxResponsesMessage: "Sólo se permiten {{maxSelection}} respuestas.",
                    play: "jugar",
                    playPrevious: "Reproducir Anterior",
                    playNext: "Reproducir Siguiente",
                    playing: "Reproduciendo",
                    progress: "Progreso",
                    pause: "Pausar",
                    ready: "Listo",
                    replay: "Repetir",
                    resume: "Reanudar",
                    retry: "Reintentar",
                    saveComplete: "Guardado completado",
                    saveInProgress: "Guardado en progreso",
                    submitButtonLabel: "Entregar",
                    submitComplete: "Enviada",
                    submitInProgress: "Sumisión...",
                    stop: "Parar",
                    volume: "Volumen",
                    graphingTools: {
                        point: "Punto"
                    },
                    drawing: {
                        toolbar: {
                            straightedge: "Línea",
                            scribble: "Garabatear",
                            compass: "Brújula",
                            text: "Texto",
                            eraser: "Borrador",
                            clear: "Claro",
                            undo: "Deshacer",
                            redo: "Rehacer"
                        }
                    }
                }
            }
        }
    }
];
exports.default = SpanishCustomLabels;
